import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useBackFromPaymentPageSpotify } from 'src/Pages/Artist/SpotifySchedulePage/helpers/useBackFromPaymentPageSpotify'
import { useCheckSpotifyCampaignStatus } from 'src/Pages/Artist/SpotifySchedulePage/helpers/useCheckSpotifyCampaignStatus'
import { useSidebarVisibility } from 'src/Hooks/useSidebarVisibility'
import { useDefaultSpotifyCampaignStartDate } from 'src/Pages/Artist/SpotifySchedulePage/helpers/useDefaultSpotifyCampaignStartDate'
import { useCheckoutTimerFeatureFlag } from 'src/Hooks/useCheckoutTimerFeratureFlag'
import { useBonusTooltipTimer } from 'src/Hooks/useBonusTooltip'
import { updateCountdown } from 'src/Redux/checkoutCountdown-process'
import { useAppDispatch } from 'src/Hooks/redux'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { setCampaignId } from 'src/Redux/selectedCuratorsSlice'

import { useScheduleStartEvent } from './helpers/useScheduleStartEvent'

export const useScheduleSpotifyCampaign = (): void => {
  const dispatch = useAppDispatch()
  const { number } = useParams()
  useBackFromPaymentPageSpotify()
  useSidebarVisibility()
  useCheckSpotifyCampaignStatus()
  useDefaultSpotifyCampaignStartDate()
  useScheduleStartEvent()
  useBonusTooltipTimer({
    platform: CampaignPlatformTypeEnum.SPOTIFY,
  })
  useCheckoutTimerFeatureFlag({
    platform: CampaignPlatformTypeEnum.SPOTIFY,
    campaignId: Number(number),
  })

  useEffect(
    () => () => {
      dispatch(updateCountdown(null))
    },
    [dispatch],
  )

  useEffect(() => {
    number && dispatch(setCampaignId(number))
  }, [dispatch, number])
}
